import Hotjar from '@hotjar/browser';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const sendHotjarIdentify = ({
  isLoggedIn,
  userId = Cookies.get('GA4ID') || null,
}: { isLoggedIn: boolean, userId?: string }): void => {
  const isAgeVerified = (): boolean => localStorage['ageVerified'] || false;
  const userScreenResolution = (): string => `${screen.width}x${screen.height}`;
  const userTimezone = dayjs().format('z');

  Hotjar.identify(userId, {
    isLoggedIn: isLoggedIn,
    age_verified: isAgeVerified(),
    time_zone: userTimezone,
    screen_resolution: userScreenResolution(),
  });
};

export { sendHotjarIdentify };
